import * as types from 'modules/devices/actionTypes';
import type { DeviceAppVersionData, FetchDevicesAppVersionSuccessAction } from 'modules/devices/types';
import { indexValues } from 'modules/devices/utils';
import { createReducer } from 'utils/ReduxUtils';

const initialState: DeviceAppVersionData = {};

const fetchSuccess = (state: DeviceAppVersionData, action: FetchDevicesAppVersionSuccessAction) => {
  const { page, content } = action.payload!;
  const baseState = page.number > 0 ? state : initialState;
  return { ...baseState, ...indexValues(content, 'lastAppVersion') };
};

export default createReducer(initialState, {
  [types.FETCH_DEVICES_APP_SUCCESS]: fetchSuccess,
});
